module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  helpers = helpers || Handlebars.helpers;
  


  return "<div id=\"cmhr-mc-socket-status\" class=\"status\" data-status=\"false\"></div>\n<div id=\"cmhr-mc-socket-msg\" class=\"msg\">Connecting...</div>";});